<template>
  <div class="price-wrap flex items-baseline justify-between;">
    <div class="flex">
      <div class="flex items-baseline"
           v-for="(price, type, index) in getTypePrice(spaceRentModelValue.rent_groups)">
        <div v-if="index > 0"
             class="unit">{{ '、' }}
        </div>
        <div class="mr-[4px] text-[20px] text-osn-dark-grey-00">
          {{ 'NT$' + parseNumber(price) }}
        </div>
        <div class="unit">{{ '/' + parseRentUnit(type) }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {parseNumber, parseRentUnit} from "~/utils/parseTool";
import {getTypePrice} from "~/utils/newPriceTool";

const spaceRentModelValue = defineModel('spaceRentObj', {type: Object, default: {}})
</script>

<style scoped lang="scss">
.price-wrap {
  .unit {
    @apply text-[14px] text-osn-grey-01;
  }

  .img-active {
    transform: rotate(180deg);
  }
}

.discount-wrap {
  .divider {
    @apply w-full h-[1px] border-b border-gray-300 mt-[10px] mb-0;
  }

  .discount-hint {
    @apply w-fit pl-[20px] pr-[14px] py-[2px] ml-[-20px] text-[18px] text-osn-dark-grey-00 font-[600] bg-osn-yellow-00
  }

  .discount-time {
    @apply text-[14px] text-osn-grey-01
  }

  .discount-price {
    @apply text-[18px] text-osn-dark-grey-00 mr-[4px]
  }
}
</style>
